export const table = (theme) => {
    return {
        footer: {
            backgroundColor: theme.colors?.surface?.default,
            textColor: theme.colors?.text?.basic?.primary,
            labelColor: theme.colors?.text?.basic?.secondary,
        },
    };
};
//# sourceMappingURL=table.js.map